import React from 'react'
import PropTypes from 'prop-types'

import './MenuSelector.css'
import { useMenuSelection } from '../../hooks/use-menu-selection'
import { useMenus } from '../../hooks/use-menus'
import { XP_SINGLE_PAGE_MENU } from '../ExperimentsProvider/experiment-definitions'
import { useExperiments } from '../ExperimentsProvider/ExperimentsProvider'

const MenuSelectorInner = ({ menus, activeMenu = { id: '' }, imperativeItemHandler, calcHeaderOffset }) => {
  const { variant } = useExperiments(XP_SINGLE_PAGE_MENU.experimentName)
  const showAllMenus = variant === 1
  const setActiveMenu = useMenuSelection({
    onCompleted () {
      imperativeItemHandler(
        (items) => items.find(({ id }) => id.includes(activeMenu.id)),
        async (node) => {
          if (window.scrollY > node.offsetTop || showAllMenus) {
            node.scrollIntoView()
            const headerOffset = await calcHeaderOffset()
            window.scrollBy(0, -headerOffset + 30)
          }
        }
      )
    }
  })

  const handleChange = event => {
    const id = event.target.value
    setActiveMenu(id)
  }

  return (
    menus.length > 1 && (
      <fieldset styleName='fieldset'>
        <legend styleName='legend'>Choose a Menu</legend>
        <select data-testid='menus-selector' styleName='select' onChange={handleChange} value={activeMenu.id} >
          {activeMenu.id === '' && <option value='' >CHOOSE A MENU</option>}
          {menus.map(({ id, name }) => (
            <option data-testid='menu-selector' key={id} id={id} value={id}>
              {name}
            </option>
          ))}
        </select>
      </fieldset>
    )
  )
}

export const MenuSelector = ({ imperativeItemHandler, activeMenu, calcHeaderOffset }) => {
  const { loading, error, menus } = useMenus({})

  if (loading || error || !menus || menus.length <= 1) {
    return null
  }

  return <MenuSelectorInner menus={menus} activeMenu={activeMenu} imperativeItemHandler={imperativeItemHandler} calcHeaderOffset={calcHeaderOffset} />
}

MenuSelector.propTypes = {
  imperativeItemHandler: PropTypes.func,
  activeMenu: PropTypes.object,
  calcHeaderOffset: PropTypes.func
}
